import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import NavigationBar from '../components/layout/NavigationBar';
import Footer from '../components/layout/Footer';
import { colors } from '../utils/colors';

function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <NavigationBar />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: colors.offWhite,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            py: 8,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '4rem', md: '6rem' },
              fontWeight: 'bold',
              color: colors.darkRed,
              mb: 2,
            }}
          >
            404
          </Typography>
          <Typography
            variant="h4"
            sx={{
              mb: 3,
              color: colors.darkRed,
            }}
          >
            Page Not Found
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: colors.black,
              maxWidth: '600px',
            }}
          >
            The page you're looking for doesn't exist. It might have been moved or deleted.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/')}
              sx={{
                backgroundColor: colors.red,
                '&:hover': {
                  backgroundColor: colors.darkRed,
                },
              }}
            >
              Go to Homepage
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate(-1)}
              sx={{
                borderColor: colors.red,
                color: colors.red,
                '&:hover': {
                  borderColor: colors.darkRed,
                  backgroundColor: 'rgba(151, 0, 0, 0.04)',
                },
              }}
            >
              Go Back
            </Button>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}

export default NotFound;
